import { render, staticRenderFns } from "./batch-ok.vue?vue&type=template&id=37b40b5d&scoped=true"
import script from "./batch-ok.vue?vue&type=script&lang=js"
export * from "./batch-ok.vue?vue&type=script&lang=js"
import style0 from "./batch-ok.vue?vue&type=style&index=0&id=37b40b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b40b5d",
  null
  
)

export default component.exports